import TeamList from '../components/team/TeamList';
import { useApp } from '../context/AppContext';
import TaskModal from '../components/task/TaskModal';

export default function TeamsPage() {
  const { state, dispatch } = useApp();
  const selectedTask = state.tasks.find(t => t.id === state.selectedTaskId);

  return (
    <>
      <TeamList />
      {selectedTask && (
        <TaskModal
          task={selectedTask}
          onClose={() => dispatch({ type: 'SELECT_TASK', payload: null })}
        />
      )}
    </>
  );
}
